<div>
  <app-sidebar></app-sidebar>
  <div class="relative md:mr-64 ">
    <app-admin-navbar></app-admin-navbar>
    <app-header-stats></app-header-stats>
    <div class="p-4 md:px-10 ml-3 md:w-10/12 w-full -m-24">
      <router-outlet></router-outlet>
      <!-- <app-footer-admin></app-footer-admin> -->
    </div>
  </div>
</div>
